import moment from "moment";

type Order = 'asc' | 'desc';

function getComparator<T>(order: Order, orderBy: keyof T) {
  return order === 'desc'
    ? (a: T, b: T) => descendingComparator(a, b, orderBy)
    : (a: T, b: T) => -descendingComparator(a, b, orderBy, false);
}

function isNumeric(n: any): boolean {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T, placeEmptyAtEnd = true): number {
  const aVal = a[orderBy];
  const bVal = b[orderBy];

  // Type-safe empty value checking
  if ((aVal === null || aVal === "-" || aVal === "") &&
      (bVal === null || bVal === "-" || bVal === "")) {
    return 0;
  } else if (aVal === null || aVal === "-" || aVal === "") {
    return placeEmptyAtEnd ? 1 : -1;
  } else if (bVal === null || bVal === "-" || bVal === "") {
    return placeEmptyAtEnd ? -1 : 1;
  }

  // Try date comparison with type assertion
  const bDate = moment(bVal as any);
  const aDate = moment(aVal as any);
  if (aDate.isValid() && bDate.isValid()) {
    if (bDate.isBefore(aDate)) return -1;
    if (bDate.isAfter(aDate)) return 1;
    return 0;
  }

  if (isNumeric(aVal) && isNumeric(bVal)) {
    return (bVal as number) - (aVal as number);
  }

  if ((bVal as any) < (aVal as any)) return -1;
  if ((bVal as any) > (aVal as any)) return 1;
  return 0;
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number): T[] {
  const stabilizedThis = array.map((el: T, index: number) => [el, index] as [T, number]);
  stabilizedThis.sort((a: [T, number], b: [T, number]) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el: [T, number]) => el[0]);
}


export {descendingComparator, getComparator, stableSort};
